import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    diffTime: null,
    price: {
      available: false,
      time: null,
      close: 0,
      change: 0,
      percent: 0,
      high: 0,
      low: 0,
      vol: 0,
      val: 0,
      open: 0
    }
  },
  getters: {
    diffTime: (state) => {
      if(state.diffTime === null)
        return 0
      else
        return state.diffTime
    },
    getPrice: (state) => {
      return state.price
    }
  },
  mutations: {
    UPDATE_DIFFTIME(state, diff) {
      console.log('UPDATE_DIFFTIME', diff)
      state.diffTime = diff
    },
    UPDATE_PRICE(state, price) {
      state.price = price
    }
  },
  actions: {
    updateDifftime({ commit }, payload) {
      commit('UPDATE_DIFFTIME', payload)
    },
    updatePrice({ commit }, payload) {
      commit('UPDATE_PRICE', payload)
    }
  },
  modules: {
  }
})
